/**
 * axios setup to use mock service
 */

import axios from 'axios';

let localUrl = localStorage.getItem('base-url');

localUrl = localUrl ? `https://${localUrl}/` : 'https://api.ahxwwl.com/';

const REQUEST_SOURCE = 'web';

const axiosServices = axios.create({ baseURL: localUrl || 'http://localhost:3010/' });

let spareUrl = 'https://' + localStorage.getItem('backup-url');

const withSourceValue = (value?: unknown) => {
    if (value instanceof URLSearchParams) {
        value.set('source', REQUEST_SOURCE);
        return value;
    }

    if (value && typeof value === 'object' && !Array.isArray(value) && !(value instanceof FormData)) {
        return {
            ...value,
            source: REQUEST_SOURCE
        };
    }

    return { source: REQUEST_SOURCE };
};

const withoutSourceValue = (value?: unknown) => {
    if (value instanceof FormData) {
        value.delete('source');
        return value;
    }

    if (value instanceof URLSearchParams) {
        value.delete('source');
        return value;
    }

    if (value && typeof value === 'object' && !Array.isArray(value)) {
        const nextValue = { ...(value as Record<string, unknown>) };
        delete nextValue.source;
        return nextValue;
    }

    return value;
};

const retryRequest = async (error: any) => {
    const originalRequest = error.config;
    console.error(`切换到 ${spareUrl} 重新请求`);
    originalRequest.baseURL = spareUrl;
    try {
        const res = await axios(originalRequest);
        return res;
    } catch (err) {
        console.log('error', error);
        console.error('error.response', error.response);
        return Promise.reject(err);
    }
};
axiosServices.interceptors.request.use((config) => {
    // 动态获取参数，例如从localStorage获取locale
    const locale = localStorage.getItem('locale');
    const requestMethod = (config.method || 'get').toLowerCase();
    const requestUrl = (config.url || '').split('?')[0];

    config.headers['Lang'] = locale ? locale : 'tc';

    if (requestUrl === '/auth' || requestUrl.endsWith('/auth')) {
        if (requestMethod === 'get' || requestMethod === 'head') {
            config.params = withoutSourceValue(config.params);
        } else {
            config.data = withoutSourceValue(config.data);
        }

        return config;
    }

    if (requestMethod === 'get' || requestMethod === 'head') {
        config.params = withSourceValue(config.params);
        return config;
    }

    if (config.data instanceof FormData) {
        config.data.set('source', REQUEST_SOURCE);
    } else if (config.data instanceof URLSearchParams) {
        config.data.set('source', REQUEST_SOURCE);
    } else {
        config.data = withSourceValue(config.data);
    }

    return config;
});

// interceptor for http
axiosServices.interceptors.response.use(
    (response) => {
        return response;
    },
    (error) => {
        if (error.config.baseURL !== spareUrl) {
            return retryRequest(error);
        }

        return Promise.reject((error.response && error.response.data) || 'Wrong Services');
    }
);

export default axiosServices;
